import { render, staticRenderFns } from "./MStoreRelatedDocumentsTab.vue?vue&type=template&id=3ac36ebe&"
import script from "./MStoreRelatedDocumentsTab.vue?vue&type=script&lang=ts&"
export * from "./MStoreRelatedDocumentsTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports